import React from 'react';
import { Grid, TextInput } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';

interface AuditFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

export const AuditFilters: React.FC<AuditFiltersProps> = ({
  searchTerm,
  onSearchChange,
}) => {
  return (
    <Grid mb="lg">
      <Grid.Col span={{ base: 12, md: 8 }}>
        <TextInput
          placeholder="Nach Dienststelle suchen..."
          leftSection={<IconSearch size={16} />}
          value={searchTerm}
          onChange={(e) => onSearchChange(e.currentTarget.value)}
        />
      </Grid.Col>
    </Grid>
  );
};
